import React, { useEffect, useRef } from 'react';

const Img = (props) => {
  const bgImg = useRef(null);
  const alt = props;
  useEffect(() => {
    const image = bgImg.current;
    if (image.classList.contains('bg-img')) {
      const parentElement = image.parentElement;
      parentElement.classList.add('bg-size');
      image.style.display = 'none';
      parentElement.setAttribute(
        'style',
        `
        background-image: url(${props.src});
        background-size:cover; 
        background-position: center;
        background-repeat: no-repeat;
        display: block;
        `,
      );
    }
  }, [bgImg, props.src]);

  return <img ref={bgImg} {...props} alt={alt} />;
};
export default Img;
